export function focusReference(component, reference, childIndex = null) {
    component.$nextTick(() => {
        if (!component.$refs) {
            return; // No references found at all
        }

        if (!component.$refs.hasOwnProperty(reference)) {
            return; // Reference not found
        }

        let ref = component.$refs[reference];

        if (!ref) {
            return; // That particularly reference, while set, wasn't set as anything
        }

        if (!ref.$el) {
            return; // No elements found
        }

        let element = ref.$el;

        if (!element) {
            return; // Element doesn't exist
        }

        if (childIndex !== null) {
            let children = element.$children;

            if (!element.$children) {
                return; // Element has no children
            }

            if (element.$children.length < childIndex) {
                return; // Child index <childIndex> was not found
            }

            if (!element.$children[childIndex]) {
                return; // Element doesn't exist
            }

            element = element.$children[childIndex];
        }

        console.log('Focusing ', element, reference);

        element.focus();
    });
}